import { render, staticRenderFns } from "./supplier.vue?vue&type=template&id=79990dfa&scoped=true&"
import script from "./supplier.vue?vue&type=script&lang=ts&"
export * from "./supplier.vue?vue&type=script&lang=ts&"
import style0 from "./supplier.vue?vue&type=style&index=0&id=79990dfa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79990dfa",
  null
  
)

export default component.exports